import { ICustomerPaymentListParams, ICustomerPaymentResponse } from 'shared';

import { CacheTags } from '../../types/cacheTags';
import { emptySplitApi } from '../baseApi';

export const customerPaymentsApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    fetchCustomerPayments: builder.query<ICustomerPaymentResponse, ICustomerPaymentListParams & { organisationId: string }>({
      query: ({ organisationId, ...params }) => ({
        url: `customerPayments`,
        method: `GET`,
        headers: {
          [`X-Organisation-Id`]: organisationId,
        },
        params,
      }),
      providesTags: [
        { type: CacheTags.CustomerPayments, id: `LIST` },
      ],
    }),
    retrySync: builder.mutation<unknown, { organisationId: string; customerPaymentId: number }>({
      query: ({ organisationId, customerPaymentId }) => ({
        url: `customerPayments/${customerPaymentId}/retry-sync`,
        method: `POST`,
        headers: {
          [`X-Organisation-Id`]: organisationId,
        },
      }),
      invalidatesTags: [
        { type: CacheTags.CustomerPayments, id: `LIST` },
      ],
    }),
  }),
});

export const {
  useFetchCustomerPaymentsQuery,
  useRetrySyncMutation,
} = customerPaymentsApi;
